import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("FooterContainerWidget", {
  title: "Footer Container",
  attributes: {
    columnAmount: {
      title: "Column amount",
      description: "Default: 3",
    },
  },
  initialContent: {
    columnAmount: "3",
  },
  properties: ["columnAmount", "headline"],
});
